import apolloClient from '../../apolloClient';
import resolutionQueries from 'src/gql/queries/resolution';
import workspaceMutation from 'src/gql/mutations/workspace';
import workspaceQueries from 'src/gql/queries/workspace';

const createWorkspace = async (variables) =>
  apolloClient.mutate({
    mutation: workspaceMutation.CREATE_WORKSPACE,
    variables,
  });

const getWorkspaceById = async (variables) =>
  apolloClient.query({
    query: workspaceQueries.GET_WORKSPACE_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const getDevicesByWorkspace = async (variables) =>
  apolloClient.query({
    query: workspaceQueries.GET_DEVICES_BY_WORKSPACE,
    fetchPolicy: 'no-cache',
    variables,
  });

const getUsersByWorkspace = async (variables) =>
  apolloClient.query({
    query: workspaceQueries.GET_USERS_BY_WORKSPACE,
    fetchPolicy: 'no-cache',
    variables,
  });

const getInvitationsByWorkspace = async (variables) =>
  apolloClient.query({
    query: workspaceQueries.GET_INVITATIONS_BY_WORKSPACE,
    fetchPolicy: 'no-cache',
    variables,
  });

const getBrandsByWorkspaceId = async (variables) =>
  apolloClient.query({
    query: workspaceQueries.GET_BRAND_BY_WORKSPACE_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const getModelsByWorkspaceId = async (variables) =>
  apolloClient.query({
    query: workspaceQueries.GET_MODEL_BY_WORKSPACE_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const getEventsByWorkspaceId = async (variables) =>
  apolloClient.query({
    query: workspaceQueries.GET_EVENT_BY_WORKSPACE_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const getEventsByWorkspaceIdAndProtocolId = async (variables) =>
  apolloClient.query({
    query: workspaceQueries.GET_EVENT_BY_WORKSPACE_ID_AND_PROTOCOL_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const getResolutionsByWorkspaceId = async (variables) =>
  apolloClient.query({
    query: resolutionQueries.GET_RESOLUTIONS_BY_WORKSPACE_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const updateWorkspaceById = async (variables) =>
  apolloClient.mutate({
    mutation: workspaceMutation.UPDATE_WORKSPACE_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

export default {
  createWorkspace,
  getWorkspaceById,
  getDevicesByWorkspace,
  getUsersByWorkspace,
  getInvitationsByWorkspace,
  getBrandsByWorkspaceId,
  getModelsByWorkspaceId,
  getEventsByWorkspaceId,
  getEventsByWorkspaceIdAndProtocolId,
  getResolutionsByWorkspaceId,
  updateWorkspaceById,
};
